import { useMemo } from "react";

import { useFormContext, useWatch } from "react-hook-form";

import { FieldParameter } from "@fartherfinance/frontend/api/TaskWorkflows/Types";

import { extractRefsFromExpressions } from "../../expressions/utils/parameterExtractors";

interface FieldDependencies {
  determinedBy: string[];
  requiredRefs: string[];
  validationRefs: string[];
  allDependencies: string[];
}

interface UseFieldDependenciesReturn {
  dependencies: FieldDependencies;
  dependencyValues: unknown;
}

export const useFieldDependencies = (
  fieldParameter: FieldParameter
): UseFieldDependenciesReturn => {
  const { control } = useFormContext();

  const dependencies = useMemo(() => {
    const determinedBy = fieldParameter.determinedBy || [];

    const requiredRefs =
      "required" in fieldParameter.display &&
      Array.isArray(fieldParameter.display.required)
        ? extractRefsFromExpressions(fieldParameter.display.required)
        : [];

    const validationRefs = fieldParameter.dataType?.validation
      ? extractRefsFromExpressions(fieldParameter.dataType.validation)
      : [];

    const allDependencies = [
      ...new Set([...determinedBy, ...requiredRefs, ...validationRefs]),
    ];

    return {
      determinedBy,
      requiredRefs,
      validationRefs,
      allDependencies,
    };
  }, [fieldParameter]);

  const dependencyValues = useWatch({
    control,
    name:
      dependencies.allDependencies.length > 0
        ? dependencies.allDependencies
        : [],
  });

  return {
    dependencies,
    dependencyValues,
  };
};
